export const colors = {
  yellow: "Yellow",
  orange: "Orange",
  red: "Red",
  purple: "Purple",
  blue: "Blue",
  green: "Green",
};
